export const SOURCE_NAME = "SOURCE"
export const getConstants = (env="mainnet-beta") => {
  switch (env) {
    case "mainnet-beta":
      return {
        solana: {
          RPC: "https://ssc-dao.genesysgo.net/",
          // RPC: 'https://api.mainnet-beta.solana.com',
          NETWORK: env,
        },
      };
    case "devnet":
      return {
        MALLOC_PROGRAM_ID: "9i4MAnhYagLr1vEo5jdmLehRe8Sm5Lx8fHaQNJfbFCve",
        mallocSpl: {
          TRANSFER_PROGRAM_ID: "ETpyJNQLorJbAcrPQpM9bkYxYMakegBh93kqZ1KnTBjr",
          SWAP_PROGRAM_ID: "7T6seoCvCQeUeSTf2EAwX5SnyrZvX7BFUMHi74ZodBKH",
          DUMMY_PASS_THROUGH: "DBhGd4VREBAw14vV1yaLXfCTtanPBwQfEErg1fe27diJ",
          MINT_TO: "77WQMNHSBe6BNdMY8R1FD4JX89o2fXr5FhKNerTcJsHJ",
          SOLEND_ACTION: "BVmJHQLHAAdgALGi6rdGxdsk5ate41kbpDMGL9XAVanP",
        },
        projectSerum: {
          DEX_PROGRAM_ID: "DESVgJVGajEgKGXhb6XmqDHGz3VjdgP7rEVESBgxmroY",
        },
        demo: {
          FAKE_USDC: "AkzN2jJrorpUY2ApfL2UsBeTfuv1XHFKGLQurZJg6BhN",
          FAKE_USDC_GD: "2BB7fDrLgBNSMCLqD835GisCHrHrGHsS8SJr6brtnWk2",
          FAKE_TOKEN_A: "9GmQdigrAFdX67EMrVFwMepEN8rEdMdp8CPUEPJRY8sj",
        },
        INITIAL_SPLITTER_ID_UUID: "initial",
        solana: {
          RPC: "https://explorer-api.devnet.solana.com",
          NETWORK: env,
        },
      };

    default:
      throw "Unexpected env";
  }
  throw "Unexpected env";
};
